import PolicyLayout, { Section, P, Ul } from '../components/PolicyLayout';

export default function TermsAndConditions() {
  return (
    <PolicyLayout art="terms" title="Terms &amp; conditions" description="Please read these Terms and Conditions carefully before using our services. By accessing or using NephroCore, you agree to be bound by these terms.">
      <div className="nc-policy-note"><strong>NephroCore Nexus (OPC) Private Limited</strong><p>These Terms and Conditions regulate the access to and use of the services offered by NephroCore Nexus (OPC) Private Limited (hereinafter referred to as the "Company", "we", "us", or "our"), including, inter alia, diagnostic testing, laboratory services, and medical consultations.</p><p>Any person accessing or availing of our services shall be deemed to have read, understood, and expressly accepted these Terms and Conditions, which are binding in nature.</p></div>
        <Section num="1" title="Introduction">
          <P>
            These Terms and Conditions regulate the access to and use of the services offered by NephroCore Nexus (OPC) Private Limited, including, inter alia, diagnostic testing, laboratory services, and medical consultations.
          </P>
          <P>
            Any person accessing or availing of the services (hereinafter referred to as the "User" or "you") shall be deemed to have read, understood, and expressly accepted these Terms and Conditions, which shall be binding in nature.
          </P>
        </Section>

        <Section num="2" title="Scope of Services">
          <Ul items={[
            'The Company provides diagnostic testing, blood sample collection, and doctor consultation services.',
            'All reports, opinions, and consultations are indicative and informational in nature and shall not be construed as definitive medical advice, diagnosis, or treatment.',
            'In case of a medical emergency, Users are advised to immediately contact the nearest hospital or qualified medical practitioner.',
          ]} />
        </Section>

        <Section num="3" title="User Obligations">
          <Ul items={[
            'Users shall provide true, complete, and accurate personal and medical information.',
            'The Company reserves the right to require KYC verification for certain services or benefits.',
            'Any fraudulent, misleading, or false booking may result in cancellation without refund and possible legal action.',
          ]} />
        </Section>

        <Section num="4" title="Payments and Pricing">
          <Ul items={[
            'Payments may be required in advance for confirmation of services.',
            'Prices are subject to change at the Company\'s discretion without prior notice.',
            'A booking shall be deemed confirmed only upon successful receipt of payment.',
          ]} />
        </Section>

        <Section num="5" title="Cancellation and Refund Policy">
          <Ul items={[
            'Users may cancel a booking prior to initiation of service.',
            'Approved refunds shall be subject to a 20% processing deduction.',
            'The balance amount shall be refunded to the original payment method within 5–7 working days.',
            'No refund shall be processed once the service has commenced, including sample collection.',
          ]} />
        </Section>

        <Section num="6" title="Non-Refundable Situations">
          <P>Refunds shall not be issued in the following cases:</P>
          <Ul items={[
            'Test already conducted',
            'Sample collected',
            'Incorrect or incomplete information provided by the User',
            'Failure of the User to attend the scheduled appointment',
          ]} />
        </Section>

        <Section num="7" title="Privacy and Data Protection">
          <Ul items={[
            'The Company collects and processes User data solely for healthcare and operational purposes.',
            'Reasonable security practices are implemented in compliance with applicable Indian laws, including data protection standards.',
          ]} />
        </Section>

        <Section num="8" title="Limitation of Liability">
          <Ul items={[
            'The Company shall not be liable for any indirect, incidental, consequential, or special damages, including loss of data, health outcomes, or financial loss arising from use of services.',
            'All diagnostic reports and consultations are advisory and reliance on them is at the User\'s discretion.',
          ]} />
        </Section>

        <Section num="9" title="Arbitration and Dispute Resolution">
          <Ul items={[
            'Any dispute arising out of or in connection with these Terms or services shall be resolved through arbitration in accordance with the Arbitration and Conciliation Act, 1996.',
            'The arbitration shall be conducted by a sole arbitrator mutually appointed by the parties.',
            'The seat and venue of arbitration shall be Delhi, India.',
            'The arbitral award shall be final and binding on the parties.',
          ]} />
        </Section>

        <Section num="10" title="Modification of Terms">
          <P>
            The Company reserves the right to modify or update these Terms at any time. Continued use of services after such changes shall constitute acceptance of the revised Terms.
          </P>
        </Section>

        <Section num="11" title="Governing Law and Jurisdiction">
          <P>
            These Terms shall be governed by the laws of India. Subject to arbitration, courts at Delhi shall have exclusive jurisdiction.
          </P>
        </Section>

        <Section num="12" title="Contact Information">
          <P>For any queries or concerns relating to these Terms, please contact us at:</P>
          <div className="nc-policy-note"><strong>NephroCore Nexus (OPC) Private Limited</strong><p><a href="mailto:support@nephrocorenexus.com">support@nephrocorenexus.com</a></p></div>
        </Section>
    </PolicyLayout>
  );
}
